import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Institution } from "../../../../../models/institution";
import { Registration } from "../../../../../models/registration";
import { RegistrationInstitution } from "../../../../../models/registration-institution";
import { InstitutionControllerService } from "../../../../../services/institution-controller/institution-controller.service";
import { RegistrationInstitutionControllerService } from "../../../../../services/institution-controller/institution-registration-controller.service";
import { InstitutionService } from "../../../../../services/institution-controller/institution.service";
import { Store } from "../../../../../services/store.service";
import { UnitService } from "../../../../../services/unit-controller/unit.service";
import {environment} from "../../../../../../environments/environment";
import {TranslatedBaseError} from "../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "institution",
  templateUrl: "institution.component.html",
  providers: [InstitutionControllerService, RegistrationInstitutionControllerService, ToastrService],
})
export class InstitutionComponent extends TranslatedBaseError implements OnInit, OnChanges, OnDestroy {
  @Input() public registration: Registration;
  @Input() public serviceId: string;
  @Input() public isRequired: boolean;
  @Input() public registrationUnitsLength: number = 0;
  @Input() public disabled: boolean = false;
  @Input() public registrationInstitution: RegistrationInstitution;
  @Output() public modalClosedEvent = new EventEmitter();
  @Output() public registrationInstitutionsLength = new EventEmitter();
  public showInstitutionModal: boolean;
  public selectedInstitution: Institution;
  public institution: Institution;
  public institutions: Institution[] = [];
  public selectedInstitutions: Institution[] = [];

  public searchInstitutionFilter: any;

  public addNew: boolean = false;
  public showDeterminantBuilder: boolean = false;
  public showList: boolean = false;
  public showInstitution = {};

  public subscription: any;

  constructor(private registrationInstitutionControllerService: RegistrationInstitutionControllerService,
              private institutionControllerService: InstitutionControllerService,
              private institutionService: InstitutionService,
              private unitService: UnitService,
              public toastr: ToastrService,
              public translateService: TranslateService,
              public store: Store) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.subscription = this.institutionService.update.subscribe((data) => {
      if (data.update) {
        console.log("institutionService update subscribed");
        this.loadRegistrationInstitutions();
      }
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.registration && changes.registration.currentValue) {
      this.registration = changes.registration.currentValue;
      this.loadRegistrationInstitutions();
    }
  }

  public loadInstitutions() {
    this.institutionControllerService.getInstitutions().subscribe(
      (data) => {
        this.institutionService.institutions = data;
        this.getName(data);
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public loadRegistrationInstitutions() {
    if (this.registration && this.registration.id) {
      this.registrationInstitutionControllerService.getRegistrationInstitution(this.registration.id).subscribe(
        (data) => this.updateData(data),
      );
    }
  }

  public updateData(data) {
    this.showList = false;

    this.registrationInstitution.id = data?.id || null;
    this.registrationInstitution.registrationId = data?.registrationId || null;
    this.registrationInstitution.institutionId = data?.institutionId || null;

    if (this.registrationInstitution?.id) {
      this.registrationInstitutionsLength.emit({ registrationInstitutionsLength: 1 });
    } else {
      this.registrationInstitutionsLength.emit({ registrationInstitutionsLength: 0 });
    }
    this.loadInstitutions();
  }

  public getName(data) {
    this.showInstitution = {};
    this.institutions = data.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
    });
    if (this.institutions != null) {
      for (const entry of this.institutions) {
        this.showInstitution[entry.id] = true;
        if (this.registrationInstitution && this.registrationInstitution.institutionId === String(entry.id)) {
          this.registrationInstitution.name = entry.name;
          this.showInstitution[entry.id] = false;
        }
      }
    }
  }

  public fixVisualEffectOnInstitutionSelected(institution: Institution): void {
    this.showList = false;
    // const newregistrationInstitution: RegistrationInstitution = new RegistrationInstitution();
    this.registrationInstitution.registrationId = this.registration.id;
    this.registrationInstitution.institutionId = institution.id;
    this.registrationInstitution.name = institution.name;
    // this.registrationInstitution = newregistrationInstitution;
  }

  public addRegistrationInstitution(institution: Institution) {
    console.log("--- addRegistrationInstitution", institution);
    const selectedInstitution = institution[0];
    if (!this.disabled && this.registration) {
      if (this.registrationInstitution) {
        if (!this.registrationUnitsLength) {

          // for visual effect
          this.fixVisualEffectOnInstitutionSelected(selectedInstitution);

          this.registrationInstitutionControllerService.createRegistrationInstitution(this.registration.id, selectedInstitution.id).subscribe(
            () => {
              this.responseSuccessful("Institution added to Registration!");
              this.loadRegistrationInstitutions();
              this.unitService.updateData();
            },
            (error) => this.showErrorMessageWithTitle("Error HTTP Post Service ", error),
          );
        } else {
          this.error("Remove Unit before changing Institution", "Error");
        }
      } else {
        // for visual effect
        this.fixVisualEffectOnInstitutionSelected(selectedInstitution);

        this.registrationInstitutionControllerService.createRegistrationInstitution(this.registration.id, selectedInstitution.id).subscribe(
          () => {
            this.responseSuccessful("Institution added to Registration!");
            this.loadRegistrationInstitutions();
            this.unitService.updateData();
          },
          (error) => this.showErrorMessageWithTitle("Error HTTP Post Service ", error),
        );
      }
    }
  }

  public deleteRegistrationInstitution(isConfirmed: boolean, regInstitutionId: string) {
    if (!this.disabled && isConfirmed) {
      if (!this.registrationUnitsLength) {
        this.registrationInstitutionControllerService.deleteRegistrationInstitution(regInstitutionId).subscribe(
          () => this.loadRegistrationInstitutions(),
        );
      } else {
        this.error("Remove Unit before deleting Institution", "Error");
      }
    }
  }

  public openEdit(regInstitution: any, name?: string) {
    if (!this.disabled) {
      if (regInstitution) {
        this.addNew = false;
        if (Boolean(environment.KEYCLOAK_ACTIVE)) {
          return this.institutionControllerService.getInstitution(regInstitution.institutionId).subscribe(
            (inst) => {
              this.institution = inst;
              this.updateEditData();
            });
        }
        for (const institution of this.institutions) {
          if (String(institution.id) === regInstitution.institutionId) {
            this.institution = institution;
          }
        }

      } else {
        this.institution = new Institution();
        if (name) {
          this.institution.name = name;
          this.institution.shortName = name.substring(0, 20);
        } else if (this.searchInstitutionFilter !== undefined) {
          this.institution.name = this.searchInstitutionFilter.name;
          this.institution.shortName = this.searchInstitutionFilter ? this.searchInstitutionFilter.name.substring(0, 20) : "";
        }
        this.addNew = true;
      }
      this.updateEditData();
    }
  }

  public showOrAdd() {
    if (!this.disabled) {
      if (this.institutions.length > 0) {
        this.showList = !this.showList;
      } else {
        this.openEdit(false);
      }
    }
  }

  public updateEditData() {
    if (!this.disabled) {
      this.showList = false;
      this.store.state.common.sections.type = "institution";
      this.institutionService.institution = JSON.parse(JSON.stringify(this.institution)); // mini-hack so the list doesn't update when working in edit layer
      this.institutionService.registration = this.registration;
      this.institutionService.registrationInstitution = this.registrationInstitution;
      this.institutionService.registrationUnitsLength = this.registrationUnitsLength;
      this.institutionService.addNew = this.addNew;
      this.institutionService.initEdit();
    }
  }

  public searchInstitutionChanged(value: any): void {
    this.searchInstitutionFilter = { name: value };
  }

}
